import { injectable, inject } from 'inversify'

import { ResourceService } from '../services'

@injectable()
export class ResourceSupport {
  protected config: ReturnType<typeof useRuntimeConfig>
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(@inject(ResourceService) readonly service: ResourceService) {
    this.config = useRuntimeConfig()
    this.appConfig = useAppConfig()
  }

  getResourceUrl(resourceId: string) {
    const apiUrl = import.meta.server
      ? this.config.API_BASE_URL || this.config.public.API_BASE_URL
      : this.config.public.API_BASE_URL

    const url = new URL(
      `/showcases/v1/${this.appConfig.host}/resources/file/${resourceId}`,
      apiUrl,
    )
    return url.toString()
  }
}
